import React from "react";
import { List, ListItem, ListItemText } from "@material-ui/core";
import { isSameDay } from "date-fns";
var isSameRange = function (first, second) {
    var fStart = first.startDate, fEnd = first.endDate;
    var sStart = second.startDate, sEnd = second.endDate;
    if (fStart && sStart && fEnd && sEnd) {
        return isSameDay(fStart, sStart) && isSameDay(fEnd, sEnd);
    }
    return false;
};
var DefinedRanges = function (props) {
    return (React.createElement(List, null, props.ranges.map(function (range, idx) { return (React.createElement(ListItem, { button: true, key: idx, onClick: function () { return props.setRange(range); } },
        React.createElement(ListItemText, { primaryTypographyProps: {
                variant: "body2",
                style: {
                    fontWeight: isSameRange(range, props.selectedRange)
                        ? "bold"
                        : "normal"
                }
            } }, range.label))); })));
};
export default DefinedRanges;
//# sourceMappingURL=DefinedRanges.js.map